<div mat-dialog-content class="mat-typography">
    {{message}}
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No</button>
    <button mat-button color="warn"  [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</div>